import { Component, OnInit, inject } from '@angular/core';
import { ServersContext } from '../../../../admin/contexts/servers.context';
import { CustomCucmReport, Server } from '../../../../shared/models/generated/ziroModels';
import { ZiroFormConfig } from '../../../../forms/ziro-forms-models';
import { ActivatedRoute, Router } from '@angular/router';
import { BreadcrumbsService } from '../../../../shared/breadcrumbs/breadcrumbs.service';
import { CucmQueriesResource } from '../../resources/cucm-queries.resource';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'ziro-cucm-report-builder',
  templateUrl: './cucm-report-builder.component.html',
  styleUrls: ['../../../reporting.scss'],
  standalone: false,
})
export class CucmReportBuilderComponent implements OnInit {
  private _serversContext = inject(ServersContext);
  private _router = inject(Router);
  private _activatedRoute = inject(ActivatedRoute);
  private _breadcrumbsService = inject(BreadcrumbsService);
  private _cucmQueriesResource = inject(CucmQueriesResource);
  private _route = inject(ActivatedRoute);

  isLoading = false;
  servers: Server[] = [];
  formConfig: ZiroFormConfig;
  isNewReport: boolean;
  reportId: string;
  breadCrumbLabel: string;
  report: CustomCucmReport;
  allReports: CustomCucmReport[];

  ngOnInit(): void {
    this.isNewReport = this._router.url.endsWith('/new-report');
    this.breadCrumbLabel = 'tkey;reports.custom_reports.new_report.title';
    this.isLoading = true;

    forkJoin([this._cucmQueriesResource.getAllReports(), this._serversContext._getAll()]).subscribe(
      ([reports, servers]) => {
        this.allReports = reports;
        this.servers = servers.filter((s) => s.serverType === 'CUCM');
        if (!this.isNewReport) {
          this._activatedRoute.paramMap.subscribe((params) => {
            this.reportId = params.get('reportId');
            this.report = this.allReports.find((r) => r.id === Number(this.reportId));
            if (!this.report) {
              this._router.navigate([`../new-report`], { relativeTo: this._route });
              return;
            }
            this.breadCrumbLabel = this.report.reportName;
          });
        }
        this._setBreadcrumbs();
        this.isLoading = false;
      },
    );
  }

  private _setBreadcrumbs(): void {
    this._breadcrumbsService.updateBreadcrumbs([
      { label: 'tkey;reports.custom_reports.title' },
      { label: this.breadCrumbLabel },
    ]);
  }
}
